import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import { ProveedorSesion } from './auth/sesion';
import './estilos/tokens.css';
import './estilos/base.css';

const consultas = new QueryClient({
  defaultOptions: {
    queries: {
      // Un asesor deja el panel abierto todo el día: refrescar al volver a la
      // pestaña es lo que evita trabajar sobre una bandeja de hace tres horas.
      staleTime: 30_000,
      refetchOnWindowFocus: true,
      // Reintentar un 403 o un 404 no los arregla y multiplica el ruido.
      retry: false,
    },
  },
});

const raiz = document.getElementById('raiz');
if (!raiz) throw new Error('Falta #raiz en index.html');

createRoot(raiz).render(
  <StrictMode>
    <QueryClientProvider client={consultas}>
      <BrowserRouter>
        <ProveedorSesion>
          <App />
        </ProveedorSesion>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
